// extracted by mini-css-extract-plugin
export default {"termsh1":"PrivacyPolicy_termsh1__NmZpr","section":"PrivacyPolicy_section__LgtOC","paragraph1":"PrivacyPolicy_paragraph1__-+l+X"};